
import axios from 'axios';
import {isClinicMasterOrClinic, clinicmaster_id, getClinicUserId} from './util/globalHelper'

let AxiosMaster = function () {
    // this.base = 'http://localhost:7000';
    this.base = 'https://dev.myhealthspace.in';
    // this.base = 'https://api.myhealthspace.in';
    this.ImageUrlUpload = 'https://s3.ap-south-1.amazonaws.com/';
    // this.ImageUrlUpload = 'https://s3.ap-south-1.amazonaws.com/myhealthspace/Report/';
    // this.ImageUrlUpload = 'https://s3.ap-south-1.amazonaws.com/myhealthspace/Reportdev/';
    let headersObject = {};
    if (localStorage.getItem("auth")) {
        headersObject = {
            'Content-Type': 'application/json',
            // 'token': localStorage.getItem("auth") ? `Bearer ${JSON.parse(localStorage.getItem("auth_token"))}` : ``,
            'Authorization': localStorage.getItem("auth") ? `Bearer ${JSON.parse(localStorage.getItem("auth_token"))}` : ``,
            'clinic': localStorage.getItem("auth") ? `${getClinicUserId()}` : ``,
            'clinic-master': localStorage.getItem("auth") ? `${clinicmaster_id()}` : ``,
        }
    }
    this.instance = axios.create({
        baseURL: this.base,
        timeout: 240000,
        headers: headersObject
    });
    this.get = function (url) {
        return this.instance.get(url)
    };
    this.post = function (url, params, headers) {
        return params ? this.instance.post(url, params, headers) : this.instance.post(url)
    };
    this.put = function (url, params) {
        return params ? this.instance.put(url, params) : this.instance.post(url)
    };
    this.getDirect = function (url) {
        return axios.get(url)
    }
};
let axiosMaster = new AxiosMaster();
export default axiosMaster;




// WEBPACK FOOTER //
// ./src/AxiosFactory.js